export const en = {
    // Language
    en: 'English',
    es: 'Spanish',

    // App
    app_loading: 'Loading. Please wait...',

    // Routes
    route_login: 'Login',
    route_settings: 'Settings',
    route_admin: 'Admin',
    route_forgot_pwd: 'Forgot password',
    route_register: 'Register',
    route_reset_pwd: 'Reset password',
    route_confirm_email: 'Confirm email',

    // Login.vue
    login_title: 'Log in to your account',
    login_title_lockout: 'Too many attempts',
    login_txt_pwd: 'Password',
    login_txt_email: 'Email',
    login_btn_login: 'Log In',
    login_btn_login_google: 'Log In with Google',
    login_msg_login_successful: 'Login successful',
    login_msg_wrong_usr_or_pwd: 'Wrong email or password',
    login_msg_login_error: 'Error on login',
    login_msg_login_error_no_google_session: 'Sign in to Google first and than come back. Thx.',
    login_msg_confirm_email: 'Please confirm your email.',
    login_msg_missing_org: 'User is not assigned to any organization.',
    login_msg_disabled: 'User is disabled',
    login_msg_approve_email: 'Your email is not approved yet. Please wait for approval',
    login_msg_lockout: 'You have attempted to log in with the wrong credentials too many times.  Please wait 15 minutes and try again.',
    login_chk_remember_me: 'Remember me',
    login_txt_new_acc: 'Or sign up',
    login_txt_reset_pwd: 'Reset your password',
    login_accepted_invite: 'You have successfully accepted invitation. Please log in.',
    login_invalid_invite_token: 'Invalid or expired token. Please ask for a new invitation link.',

    // ForgotPwd.vue
    forgot_pwd_title: 'Reset your password',
    forgot_pwd_bnt_send_reset_link: 'Send',
    forgot_pwd_msg_reset_link_sent: 'Password reset link sent to your email',
    forgot_pwd_msg_error: 'Error while sending password reset link',
    forgot_pwd_send_rst_link_to: 'Send me a reset link to:',
    forgot_pwd_invalid_token: 'Reset link expired. Sending new link in email...',

    // Forms in general
    form_msg_field_required: 'Field is required',
    form_msg_field_required_v2: '{0} is required',
    form_msg_min_length: 'Field must have at least {0} letters.',
    form_msg_email: 'Email is invalid',
    form_msg_pass_match: 'Passwords must match',
    form_msg_strong_pass: `Password needs to have a uppercase letter, a number,
                           a special character and at least 8 characters`,
    form_txt_back_to_login: 'Back to log in',
    form_txt_or_sign_up: 'Or sign up',
    form_msg_terms_agree: 'I agree',
    form_msg_terms: 'Please agree to the terms of use',
    form_msg_google_analytics: 'Wrong Google Analytics ID',

    // Register.Vue
    register_txt_title: 'HexIQ Registration',
    register_txt_firstname: 'First Name',
    register_txt_lastname: 'Last Name',
    register_txt_companyname: 'Company Name',
    register_txt_company_classification: 'Company Classification',
    register_txt_email: 'Email',
    register_txt_pass: 'Password',
    register_txt_conf_pass: 'Confirm Password',
    register_btn_register: 'Create account',
    register_btn_register_google: 'Sign up with Google',
    register_msg_email_exists: 'Email already registered. Please login.',
    register_msg_reg_successful: 'Registration complete. Please confirm your email address',
    register_msg_error: 'Error on registration',
    register_msg_invited_usr: 'You have successfully accepted an invitation. Please register to create an account',
    register_btn_expand: 'or sign up with your email address',
    registration_txt_consent: 'By choosing to {0}, you agree to the ',
    registration_txt_consent_and: 'and',
    registration_txt_privacy_policy: 'Privacy Policy',
    registration_txt_software_agreement: 'License and Account Terms',

    // Confirm email
    confirm_email_success: 'Email confirmed. Please log in.',
    confirm_email_failed: 'Email confirmation expired.',
    confirm_email_btn_resend: 'Resend email.',
    confirm_email_msg_ok: 'Email resent. Check your email client.',
    confirm_email_msg_error: 'Error while resending email',

    // Reset password
    reset_pwd_title: 'Set New Password',
    reset_pwd_btn_reset: 'Send',
    reset_pwd_btn_reset_text: 'Set',
    reset_pwd_new_password: 'New Password',
    reset_pwd_msg_success: 'Success, new password set',
    reset_pwd_msg_error: 'Error on setting new password',
    reset_pwd_msg_invalid_token: 'Link expired. Redirecting to forgot password...',

    // Confirm email
    confirm_email_title: 'Confirm your e-mail address',
    confirm_email_txt_email_to: 'We sent a confirmation email to:',
    confirm_email_txt_check_email: 'Check your email and click on confirmation link to finish setting up your account',
    confirm_email_btn_got_it: 'OK. I got it.',
    confirm_email_resend_link: 'Resend confirmation link',

    // MainHeader.Vue
    mainheader_settings: 'Settings',
    mainheader_admin: 'Admin',
    mainheader_logout: 'Logout',
    mainheader_contact_support: 'Contact Support',
    mainheader_marketmap: 'Market Map',
    mainheader_filter: 'Filter',
    mainheader_search: 'Search',
    mainheader_mapbuilder: 'Map Builder',
    mainheader_mainmenu: 'Main Menu',
    mainheader_account_settings: 'Account settings',
    mainheader_organization: 'Organization',
    mainheader_subscription_name: '{0} subscription',
    mainheader_account: 'Account',
    mainheader_medical: 'Medical',
    mainheader_manage_subscriptions: 'Subscriptions',
    mainheader_manage_invoices: 'Invoices & Receipts',
    mainheader_data_issues: 'Report Payer Data Issues',

    // NotificationCenter.vue
    notifications_title: 'Notifications',
    notifications_close: 'Close notifications',
    notifications_unread: 'Unread',
    notifications_all: 'All',
    notifications_select_all: 'Select all',
    notifications_mark_read: 'Mark as read',
    notifications_mark_all_read: 'Mark all as read',
    notifications_type: 'Type',
    notifications_type_all: 'All',
    notifications_type_tickets: 'Tickets',
    notifications_type_downloads: 'Downloads',
    notifications_type_info: 'Info',
    notifications_empty_unread: "You're all caught up",
    notifications_empty_all: 'No notifications yet',
    notifications_open_tickets: 'View tickets',
    notifications_open_downloads: 'Go to Downloads',
    notifications_open_info: 'Open',
    notifications_dismiss: 'Dismiss',
    notifications_now: 'now',

    // Settings.vue
    settings_title: 'Settings',
    settings_users_title: 'Users in',
    settings_traffic_sources_title: 'Traffic Sources in',
    settings_delete_traffic_source_title: 'Delete traffic source',
    settings_user: 'User',
    settings_email: 'Email',
    settings_role: 'Role',
    settings_org: 'Organization',
    settings_lang: 'Language',
    settings_btn_add_org: 'Add Organization',
    settings_btn_back: 'Close',
    settings_btn_connect_google_analytics: 'Connect Google Analytics data',
    setting_current_org: 'Current:',
    setting_other_org: 'Other:',
    setting_switch_org_title: 'Switch organization',
    setting_switch_org: 'Are you sure you want to switch?',
    setting_delete_org_title: 'Delete organization',
    setting_delete_org: 'Are you sure you want to delete?',
    setting_status: 'Status',
    setting_revoke: 'Revoke',
    setting_resend_invite: 'Resend invite',
    setting_active: 'Activate',
    setting_make_admin: 'Give admin rights',
    setting_revoke_admin: 'Revoke admin rights',
    setting_suspend: 'Suspend',
    setting_is_admin: 'Is Admin',
    setting_show_details: 'Show Details',

    // Admin.vue
    admin_title: 'Administration',

    // Error.vue
    error_txt: 'Error',
    error_unsupported_browser: 'Unsupported browser',
    error_unsupported_browser_txt: 'For best experience please use Google Chrome, Firefox or Safari.',

    // Modal.vue
    modal_default_title: 'This is the default title!',
    modal_default_text: 'This is default text!',
    modal_default_footer: 'This is default footer!',
    modal_btn_close: 'Close',

    // EditSettingDialog.vue
    edit_setting_title: 'Edit Setting',

    // Enums
    invite_user_default: 'Default',
    invite_user_invited: 'Invited',
    invite_user_revoked: 'Revoked',
    invite_user_active: 'Active',
    invite_user_inactive: 'Inactive',
    invite_user_suspended: 'Suspended',

    // Invite Users
    invite_users_to: 'Invite user to ',
    invite_users_title: 'Invite users',
    invite_users_text: 'You can invite users to collaborate on your project.',
    invite_users_email_placeholder: 'someone@example.com',
    invite_users_btn_add_more: 'Add more',
    invite_users_btn_submit: 'Invite users',

    // Add Organization
    add_org_title: 'Add Organization',
    add_org_text: 'This will create an organization so you can invite people to collaborate.',
    add_org_name: 'Name your organization',
    add_org_placeholder: 'Organization Name',
    add_org_domain_name: 'Domain Name',
    add_org_google_analytcs: 'Google Analytics ID',
    add_org_check_box_login: 'Login to new organization after creation',
    add_org_btn_add: 'Add Organization',
    add_org_error_org_exists: 'Organzation with that name already exists',

    // Rename Organization
    rename_org_title: 'Rename Organization',
    rename_org_text: 'Rename selected organization.',
    rename_org_name: 'Name your organization',
    rename_org_placeholder: 'Organization Name',
    rename_org_btn_add: 'Rename Organization',
    rename_org_error: 'Error while renaming organization. Try again later.',
    rename_org_error_forbiden: 'User doesn\'t have the rights to rename this organization',

    // Dialog
    dialog_confirmation: 'Confirmation',
    dialog_are_you_sure: 'Are you sure?',
    dialog_yes: 'Yes',
    dialog_no: 'No',
    dialog_ok: 'OK',
    dialog_cancel: 'Cancel',
    dialog_upload: 'Upload',
    dialog_upgrade: 'Upgrade',
    dialog_save: 'Save',
    dialog_delete_title: 'Confirm delete',
    dialog_delete_text: 'Are you sure you want to delete this request?',
    dialog_org_admin_title: 'Organization admin rights',
    dialog_org_admin_text: 'Give user organization admin rights?',
    dialog_org_revoke_admin_text: 'Revoke user organization admin rights?',
    dialog_org_revoke_invite_title: 'Revoke invite',
    dialog_org_resend_invite_title: 'Resend invite',
    dialog_org_suspend_user_title: 'Suspend user',
    dialog_org_activate_user_title: 'Activate user',

    // ChangeAvatar.vue
    change_avatar_title: 'Change photo',
    change_avatar_pick_text: 'Pick a photo (Max size 512KB)',
    change_avatar_error: 'Photo is to big. Max size is 512KB.',

    // Pagination.vue
    pagination_first: 'First',
    pagination_last: 'Last',
    pagination_no_entries: 'No matching entries',
    pagination_previous: 'Previous page',
    pagination_next: 'Next page',
    pagination_no_entries_hint: 'Try adjusting your search or filters.',


    // SidebarFilter.vue
    sidebar_filter_title: 'Filter',
    sidebar_filter_tab_facets: 'Facets',
    sidebar_filter_expand: 'Expand',
    sidebar_filter_collapse: 'Collapse',

    // AddNameDialog.vue
    add_name_dialog_title: 'Add Name',
    add_name_dialog_subtitle: 'Add Name',
    add_name_dialog_placeholder_name: 'Name',
    add_name_dialog_placeholder_description: 'Description',
    add_name_dialog_placeholder_payment_provider_id: 'Payment Provider Id',
    add_name_dialog_button_text: 'Add',


}
